// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// 引入 ElementUI
import ElementUI from 'element-ui'
import SDKMsg from './tool/postMsgSDK'
// reset
import './assets/reset/reset.css'
import './assets/ele-theme/index.css'

// Vuex
import store from './store'

// vue-router
import router from './router'

import App from './App'

Vue.config.productionTip = false
Vue.prototype.$$ = window.$

Vue.use(ElementUI)
Vue.use(SDKMsg)
Vue.use(window['vue-cropper'].default)
/* eslint-disable no-new */

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js